const lessonUrl = '/lesson';
const presentMode = 'present';

export { presentMode };
export default lessonUrl;
